module.exports = __webpack_public_path__ + "img/img34.fd6f85fa.png";